//#region  packages
import React, { useEffect, useState, useRef } from "react";
import { Layout, Menu, Drawer, Dropdown, Button, Input } from "antd";
import { AiFillFilter, AiOutlineSortAscending } from "react-icons/ai";
import { Col, Container, Row } from "react-bootstrap";
import {  useAppSelector } from "@/lib/store/hooks";
import { useRouter } from "next/router";
import ScrollToTop from "react-scroll-to-top";
import { CloseOutlined } from "@ant-design/icons";
//#endrin

//#region  component
import FilterBox from "../Inventory/FilterBox/FilterBox";
import DynamicBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import InventoryProduct from "./InventoryProduct/InventoryProduct";

//#endrin

// css
import "../HomeProductSection/HomeProductSection.css";
import "../Carrier/Carrier.css";
import "./Inventory.css";
import "../Inventory/InventoryProductSection/InventoryProductSection.css";
import "../Inventory/FilterBox/FilterBox.css";
import "../Home/HomePage.css";
import "../../app/globals.css";
import "../../../src/fonts/stylesheet.css";

// lib or helpers

import ItemPagenation from "../../Pagination/ItemPagination";
import * as appConstants from "../../utils/constants";
import { RouteOutlined } from "@mui/icons-material";

function Inventory({ initialData }) {
  const { Content, Sider } = Layout;
  const { Search } = Input;
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  const [isMobileFilterDrawerVisible, setIsMobileFilterDrawerVisible] =
    useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileFilterDrawerVisible, setMobileFilterDrawerVisible] =
    useState(true);

  // Scroll and state preservation
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollRef = useRef(null);

  const showMobileFilterDrawer = () => {
    setIsMobileFilterDrawerVisible(true);
  };

  const closeMobileFilterDrawer = () => {
    setIsMobileFilterDrawerVisible(false);
  };

  // Restore scroll position and state when returning to the component
  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem(
      "inventory-scroll-position"
    );
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  
  }, []);

  const toggleSider = () => {
    setCollapsed(!collapsed);
  };

  const toggleSiderMobile = () => {
    setMobileFilterDrawerVisible(true);
  };

  const closeSiderMobile = () => {
    setMobileFilterDrawerVisible(false);
  };

  // use func
  // const dispatch = useAppDispatch();

  const form1 = useRef(null);
  const form1_mob = useRef(null);
  const filterState = useAppSelector((state) => state.filter);

  const menu = (
    <Menu>
      <Menu.Item key="price_asc" onClick={() => handleSortChange("price_asc")}>
        Price: Low to High
      </Menu.Item>
      <Menu.Item
        key="price_desc"
        onClick={() => handleSortChange("price_desc")}
      >
        Price: High to Low
      </Menu.Item>
      <Menu.Item key="date_desc" onClick={() => handleSortChange("date_desc")}>
        Newest Arrivals
      </Menu.Item>
      <Menu.Item key="name_asc" onClick={() => handleSortChange("name_asc")}>
        A to Z
      </Menu.Item>
      <Menu.Item key="name_desc" onClick={() => handleSortChange("name_desc")}>
        Z to A
      </Menu.Item>
    </Menu>
  );

  // use states
  const [data, setData] = useState(
    initialData || { items: [], totalPages: 0, filtersResult: null }
  );

  // use state
  const [page, setPage] = useState(initialData?.currentPage || 1);
  const [processing, setProcessing] = useState(false);

  const { q } = router.query;
  if (q) {
    const form = form1.current;
    const form1Mob = form1_mob.current;
    if (form) {
      form["searchBox"].value = q;
    }

    if (form1Mob) {
      form1Mob["searchBox"].value = q;
    }
  }

  const handleSearch = (value) => {
    setSearchQuery(value);
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const handleRouteChange = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0; // Scroll the ref element to the top
      }
    };
   
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };

    
  }, [router]);

  useEffect(() => {
    mapPayloadGetItems();
  }, [searchQuery]);


  useEffect(() => {
    if (initialData) {
      setPage(initialData.currentPage);
      setData(initialData);
      setSearchQuery(searchQuery);
      
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }
  }, [initialData]);

  useEffect(() => {
    mapPayloadGetItems();
  }, [filterState]);


  
  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    // Cleanup the event listener
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router,initialData]);

  // handle pagination
  const handleChangePage = (newPage) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, [appConstants.queryKey.page]: newPage },
    });
    window.scrollTo(0, 0);
   
  };

  function queryURLFunction(updatedQuery) {
    if (updatedQuery?.page === 1) {
      delete updatedQuery.page;
    }

    updateCurrentRouter(updatedQuery);
  }

  function updateCurrentRouter(updatedQuery) {
    router.push({
      pathname: router.pathname,
      query: updatedQuery,
    });
  }

  async function mapPayloadGetItems() {
    if (!processing) {
      setProcessing(true);
      let updatedQuery = { ...router.query };

      if (filterState.priceStartRange > -1) {
        updatedQuery[appConstants.queryKey.startPrice] =
          filterState.priceStartRange;
      } else {
        delete updatedQuery[appConstants.queryKey.startPrice]; // Delete if not valid
      }

      // Price End Range
      if (filterState.priceEndRange > filterState.priceStartRange) {
        updatedQuery[appConstants.queryKey.endPrice] =
          filterState.priceEndRange;
      } else {
        delete updatedQuery[appConstants.queryKey.endPrice]; // Delete if not valid
      }

      // Locations
      if (filterState.locations.length > 0) {
        updatedQuery[appConstants.queryKey.locations] = filterState.locations;
      } else {
        delete updatedQuery[appConstants.queryKey.locations]; // Delete if empty
      }

      // Brands
      if (filterState.brandNameList.length > 0) {
        updatedQuery[appConstants.queryKey.brands] = filterState.brandNameList;
      } else {
        delete updatedQuery[appConstants.queryKey.brands]; // Delete if empty
      }


      // capacity
      if (filterState?.capacities?.length > 0) {
        updatedQuery[appConstants.queryKey.capacity] =
          filterState.capacities;
      } else {
        delete updatedQuery[appConstants.queryKey.capacity]; // Delete if empty
      }

      // Conditions
      if (filterState.conditionList.length > 0) {
        updatedQuery[appConstants.queryKey.conditions] =
          filterState.conditionList;
      } else {
        delete updatedQuery[appConstants.queryKey.conditions]; // Delete if empty
      }

      // debugger
     
      // Search Query
      if (searchQuery) {
        updatedQuery[appConstants.queryKey.search] = searchQuery;
      } else {
        delete updatedQuery[appConstants.queryKey.search]; // Delete if empty
      }

      resetPageNumber(updatedQuery);
      queryURLFunction(updatedQuery);
      setProcessing(false);
    }
  }

  function resetPageNumber(updatedQuery) {
    updatedQuery.page = 1;
  }

  const handleSortChange = (value) => {
    let updatedQuery = { ...router.query };
    updatedQuery[appConstants.queryKey.sort] = value;
    queryURLFunction(updatedQuery);
  };

  const clearFiltersFunc = () => {
    window.location.href = `/Inventory`;
  };


  return (
    <div ref={scrollRef} style={{ overflowY: 'auto', height: 'calc(100vh - 50px)'  }}>
      <Header />

      <Container className="InventoryPageWrap" >
        <div
          className="desktop-creadcrumbs"
          style={{ marginTop: "200px", marginBottom: "-180px" }}
        >
          <div className="d-breadcrumbs">
            <DynamicBreadcrumbs />
          </div>
        </div>
        <Layout
          className="inv-layout"
          style={{ backgroundColor: "transparent" }}
        >
          {/* Desktop Sidebar with filters */}
          <Sider
            className="desktop-filter-sidebar"
            breakpoint="lg"
            collapsedWidth="0"
            collapsible
            collapsed={collapsed}
            width={380}
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
            onBreakpoint={(broken) => {
              // console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              // console.log(collapsed, type);
            }}
          >
            <div className="filter-header">
              <div className="filter-title">
                <h3>Filters</h3>
                <div>
                  <Button
                    type="text"
                    onClick={clearFiltersFunc}
                    style={{ color: "#007bff" }}
                  >
                    Clear All
                  </Button>
                </div>
              </div>
              <div>
              

                <hr></hr>
              </div>
            </div>

            {data && data.filtersResult && (
              <FilterBox filtersResult={data.filtersResult} />
            )}
          </Sider>

          {/* Mobile Slider */}
          <Sider
            className="mobile-filter-sider"
            breakpoint="lg"
            collapsedWidth="0"
            collapsible
            collapsed={true}
            width={380}
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "10px",
            }}
            onBreakpoint={(broken) => {
              // console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
              // console.log(collapsed, type);
            }}
          >
            <div className="filter-header">
              <div className="filter-title">
                <h3>Filters</h3>
                <div>
                  <Button
                    type="text"
                    onClick={clearFiltersFunc}
                    style={{ color: "#007bff" }}
                  >
                    Clear All
                  </Button>
                  <Button
                    type="text"
                    onClick={toggleSiderMobile}
                    style={{ color: "#007bff" }}
                  >
                    Done
                  </Button>
                </div>
              </div>
              <div>
                {/* //selectedFilters */}
                <div className="filter-tags-container"></div>
                <hr></hr>
              </div>
            </div>

            {data && data.filtersResult && (
              <FilterBox filtersResult={data.filtersResult} />
            )}
          </Sider>

          {/* Main content area */}
          <Layout
            className="mainLayout"
            style={{ backgroundColor: "transparent" }}
          >
            <Content
              style={{
                minHeight: 280,
                // backgroundColor: "none",
              }}
            >
              {/* Search and Sort Controls */}
              <div style={{ marginBottom: "16px" }}>
                <Row className="search-filter-container" gutter={[16, 16]}>
                  {/* Search input */}
                  <Col xs={24} md={16} lg={12} className="search-container">
                    <Search
                      size="large"
                      placeholder="Search Inventory"
                      onSearch={handleSearch}
                      onChange={handleSearchChange}
                      value={searchQuery}
                      enterButton
                      className="search-input"
                      name={"searchBox"}
                    />
                    <Col className="searchfilter-btn">
                      <Button
                        block
                        className="filterbtn"
                        size="large"
                        onClick={showMobileFilterDrawer}
                      >
                        <AiFillFilter /> Filter
                      </Button>
                      <Dropdown overlay={menu} trigger={["click"]}>
                        <Button block className="sortBtnNew" size="large">
                          <AiOutlineSortAscending /> Sort by
                        </Button>
                      </Dropdown>

                      <Col />
                    </Col>
                    <div className="breadcrum-mobile">
                      <DynamicBreadcrumbs />
                    </div>
                  </Col>

                  <Col xs={12} md={4}>
                    {" "}
                  </Col>
                </Row>
              </div>

              {/* Product Cards */}
              <Row gutter={[16, 16]}>
                {/* {[...Array(8)].map((_, index) => ( */}
                <Col xs={24} sm={12} md={8} lg={12}>
                  <div className="product-wrap ProductWrap">
                    <div className="product-main-list">
                      <div className="InventoryPageWrapss">
                        {data.items.length > 0 ? (
                          data.items.map((product, index) => (
                            <div
                              className="my-3 InventoryProductw-50 "
                              key={index}
                            >
                              <InventoryProduct productDetail={product} />
                            </div>
                          ))
                        ) : (
                          <div className="NoFound ">
                            <img src="/notfound-img.webp" alt="Not Found" />
                            <h4>No matches found. Keep exploring!</h4>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                {/* ))} */}
                <ItemPagenation
                  current={page}
                  total={initialData?.totalPages || 0}
                  onChangePage={handleChangePage}
                />
              </Row>
            </Content>
          </Layout>

          {/* Filter Drawer for mobile */}
          <Drawer
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span>Filter</span>
                <div>
                  <Button
                    onClick={clearFiltersFunc}
                    style={{ marginRight: "8px" }}
                  >
                    Clear
                  </Button>
                  <Button
                    style={{
                      marginRight: "8px",
                      backgroundColor: "#043289",
                      color: "#fff",
                    }}
                    onClick={closeMobileFilterDrawer}
                  >
                    Done
                  </Button>
                </div>
              </div>
            }
            placement="left"
            closable
            onClose={closeMobileFilterDrawer}
            visible={isMobileFilterDrawerVisible}
            closeIcon={<CloseOutlined />}
            zIndex={999999}
            width={"100%"}
          >
             {data && data.filtersResult && (
              <FilterBox filtersResult={data.filtersResult} />
            )}
          </Drawer>
        </Layout>
      </Container>
      <ScrollToTop smooth color="#007bff" />
      <Footer />
    </div>
  );
}
export default Inventory;
